import { NavLink } from "react-router-dom";
import { Home, UtensilsCrossed, Wallet, ClipboardList, User } from "lucide-react";

export default function BottomNav() {
  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <div className="flex justify-around items-center">
        <NavItem to="/home" icon={<Home size={18} />} label="Home" testId="nav-home" />
        <NavItem to="/menu" icon={<UtensilsCrossed size={18} />} label="Menu" testId="nav-menu" />
        <NavItem to="/wallet" icon={<Wallet size={18} />} label="Wallet" testId="nav-wallet" />
        <NavItem to="/orders" icon={<ClipboardList size={18} />} label="Orders" testId="nav-orders" />
        <NavItem to="/profile" icon={<User size={18} />} label="Profile" testId="nav-profile" />
      </div>
    </nav>
  );
}

function NavItem({ to, icon, label, testId }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `bottom-nav-item ${isActive ? "active" : ""}`
      }
      data-testid={testId}
    >
      {icon}
      <span>{label}</span>
    </NavLink>
  );
}
